import React from "react";
import { FaChevronLeft } from "react-icons/fa";
import { appColors, appRadius, appType } from "../../utils/appTheme";

/**
 * Encabezado de pantalla (sub-pantallas): botón back circular + título/subtítulo.
 * `right`: slot opcional a la derecha.
 */
const AppHeader = ({ title, subtitle, onBack, right, style }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 12,
      padding: "6px 0 16px",
      paddingTop: "calc(6px + env(safe-area-inset-top, 0px))",
      ...style,
    }}
  >
    {onBack && (
      <button
        type="button"
        onClick={onBack}
        aria-label="Volver"
        style={{
          width: 38,
          height: 38,
          minWidth: 38,
          borderRadius: appRadius.pill,
          border: `1px solid ${appColors.line}`,
          background: appColors.surface,
          color: appColors.ink,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
          fontSize: 14,
        }}
      >
        <FaChevronLeft />
      </button>
    )}
    <div style={{ display: "flex", flexDirection: "column", minWidth: 0, flex: 1 }}>
      {/* Título único de la pantalla, en azul Habitia + fuente FT Habit. */}
      <span style={{ ...appType.screenTitle, color: appColors.blue }}>{title}</span>
      {subtitle && (
        <span style={{ ...appType.bodySm, marginTop: 2 }}>{subtitle}</span>
      )}
    </div>
    {right}
  </div>
);

export default AppHeader;
